// extracted by extract-css-chunks-webpack-plugin
module.exports = {"banner":"banner___1nqbL","banner-inner":"banner-inner___16H8-","submit":"submit___3aNzS","text":"text___33Am7"};